import { View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import { PMDescriptionCard } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";

export function addProgramDescriptionCard(
  view: View<TestAppState, DragAndDropLayout>
): void {
  const programDescriptionComponent = view.addComponent({
    component: PMDescriptionCard,
    layoutProps: {
      componentId: "programDescriptionComponent",
      title: "",
      description: "",
      labels: ["Program", "Description"],
    },
  });

  programDescriptionComponent.mapLayoutProps(({ language }) => ({
    componentId: "programDescriptionComponent",
    labels: ["Program", "Description"],
    title: getLocalizedMessage(
      language || "en",
      "reportingStructure.programDescription"
    ),
    description: getLocalizedMessage(
      language || "en",
      "showsProgramDescription"
    ),
  }));

  programDescriptionComponent.mapState(({ settings }) => ({
    text: settings?.configuration?.programDescription ?? "",
  }));
}
